import React from 'react';
import './pages.css';
import './mshops.css';
import ArrowRight from '../Components/ArrowRights.js';
import bgmshops from '../images/bglegal.webp';

function Mshops() {
    return (
        <section className='mshops pagesIndex' style={{ backgroundImage: `url(${bgmshops})` }} name='bgmshops'>
                    <div className='content'>
                        <div className='flexIndex'>
                            <div className='colIndex'>
                                    <h2><span>CIERRE DE</span><span>MERCADOSHOPS<i>-</i></span></h2>
                                    <div className='textoWorks'>
                                        <h3>Impulsa tu Marca al Siguiente Nivel con <strong>Index®</strong></h3>
                                        <p>Recientemente, Mercado Shops anunció que cerrará sus operaciones. Desde Index, estamos trabajando con ellos para acompañarlos en esta transición y que puedan seguir desarrollando sus negocios con éxito.</p>
                                    </div>
                            </div>
                            <div className='colIndex'>
                                <ArrowRight className="custom-arrow" />
                            </div>
                            <div className='colIndex'>
                                <ol className='partners flexIndex'>
                                    <li><img src='../images/partners/tiendanubeevolution.webp' alt='tienda nube'></img><a href='/tiendanube' className='buttonIndexBlack'>ver propuesta</a></li>
                                    <li><img src='../images/partners/vtex.webp' alt='vtex'></img><a href='/tiendanube' className='buttonIndexBlack disabledButton'>ver propuesta</a></li>
                                    <li><img src='../images/partners/shopify.webp' alt='shopify'></img><a href='/tiendanube' className='buttonIndexBlack disabledButton'>ver propuesta</a></li>
                                    <li><figure><img src='../images/partners/adobe.webp' alt='adobe'></img><span>(ex magento)</span></figure><a href='/tiendanube' className='buttonIndexBlack disabledButton'>ver propuesta</a></li>
                                </ol>
                            </div>
                        </div>
                    </div>
        </section>
        );
}
export default Mshops;